export default __webpack_public_path__ + "assets/wind-beaufort-12.85155275.svg";